var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "fade" } }, [
    _vm.isVisible
      ? _c(
          "div",
          {
            staticClass: "notification-screen loading-screen",
            class: _vm.cover ? "" : "no-cover"
          },
          [
            _c("div", { staticClass: "notification-screen-box" }, [
              _c(
                "div",
                { staticClass: "floating-container" },
                [
                  _c("jLottie", {
                    staticClass: "animation",
                    attrs: {
                      options: _vm.defaultOptions,
                      height: 400,
                      width: 420
                    },
                    on: { animCreated: _vm.handleAnimation }
                  }),
                  _vm._v(" "),
                  _c("h1", { staticClass: "title" }, [
                    _vm._v("\n          Please Wait\n        ")
                  ]),
                  _vm._v(" "),
                  _c(
                    "h2",
                    {
                      staticClass: "message",
                      attrs: { id: "loading-screen-message" }
                    },
                    [
                      _vm._v(
                        "\n          " + _vm._s(_vm.message) + "\n        "
                      )
                    ]
                  )
                ],
                1
              )
            ])
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-40d97baf", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40d97baf","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/notification-screen/jLoadingScreen.vue
// module id = null
// module chunks = 